<template>
<div ref="AddRecordType">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">新增记录类型</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="recordtypelist.length > 1 ? recordtypelist.length : ''" class="item">
        <el-button @click="submitData">提交数据</el-button>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="clearAll">清空已填模板</el-button>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="addpetmodel">新增模板</el-button>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="GoBackPets(false)">返回记录类型</el-button>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in recordtypelist" :key="index">
            <div class="TTL-form-submit-box-title">类型-{{index+1}}</div>
            <div class="TTL-button TTL-btn-option">
            <el-button type="del" v-if="index > 0" @click.stop="deltype(index)">删除</el-button>
            </div>
            <el-form :inline="false">
                <el-form-item>
                    <label class="TTL-form-label">图标</label>
                    <wcupload :option="{size:'large', phototype:'system'}" :value="item.icon" 
                        @finish="(val)=> {
                            item.icon=val.url;
                        }" 
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">类型名称<i>*</i></label>
                    <div class="TTL-input width300 TTL-form-input">
                    <el-input v-model="item.name" placeholder="请输入宠物名称" @change="SaveDataToBrowser" clearable />
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">一级分类</label>
                    <div class="TTL-select">
                    <el-select v-model="item.parentid" placeholder="请选择宠物品种" @change="SaveDataToBrowser" clearable>
                    <el-option v-for="(item,index) in typelist" :key="index" :label="item.typename" :value="item.id" />
                    </el-select>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_RECORD from '@/Interface/Record/Record';
import INTERFACE_MODEL_BASE from '@/Interface/index';
export default {
    components:{},
    data() {
        return {
            addlimit: 10,        //单次新增限制
            uploadimageIndex:'', //获取当前上传图片的序号
            typelist:[],        //品种信息
            recordtypelist:[
                {icon:'',name:'',parentid:''},
            ],
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            
        },


        /** 页数初始化 **/
        OnloadMethod() {
            this.GetTypeList();          //获取宠物类型信息
            this.ParseDataFromBrowser(); //解析之前填写的数据
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //兄弟组件跳转至当前组件时进行询问操作
                
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                this.ParseDataFromBrowser();
            }
        },


        /** 提交数据 **/
        submitData() {
            var checkresult=this.CheckDataBeforeSubmit();
            if(checkresult.error==1) {this.$notice({title:'提交数据提示',message:checkresult.message,type:'warning'});return false;}

            //调整提交数据
            var data=[];
            for(var i=0;i<this.recordtypelist.length;i++) data.push(this.recordtypelist[i]);
            data=JSON.stringify(data);

            var loadingobj=this.$refs.AddRecordType;
            this.$loading.openloading(loadingobj);  //加载等待动画

            INTERFACE_MODEL_RECORD.ADD_RECORD_TYPE({typedata:data}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.resetParam(); //重置当前数据
                this.$notice({title:'成功提示',message:'数据提交成功',type:'success'});
                this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
            });
        },


        /** 数据提交前进行检测 **/
        CheckDataBeforeSubmit() {
            var result={error:0,message:''};
            if(this.recordtypelist.length==0) {result={error:1,message:'请添加类型信息'};return result;}

            //检测品种参数
            var name;
            for(var i=0;i < this.recordtypelist.length;i++) {
                name=this.recordtypelist[i].name;
                if(!name || name=='') {result={error:1,message:'第'+(i+1)+'个类型名称不能为空'};return result;}
            }
            return result;
        },


        /** 新增品种模板信息 **/
        addpetmodel() {
            if(this.recordtypelist.length >= this.addlimit) {
                this.$notice({title:'消息提示',message:'单此添加数量请最多不要超过10个',type:'warning'});
                return false;
            }
            this.recordtypelist.push({icon:'',name:'',parentid:''});
            this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
        },


        /** 清空当前数据 **/
        clearAll() {
            this.$confirm.confirm(
                '您是否确定要删除当前所有类型信息 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                this.resetParam();
                this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
            }).catch(()=> {

            });
        },


        /** 删除单个品种信息 **/
        deltype(index) {
            this.recordtypelist.splice(index,1);
            this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
        },


        /** 重置加载数据 **/
        resetParam() {
            var data={icon:'',name:'',parentid:''};
            this.recordtypelist=[data];
        },


        /////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////
        //关联基础数据加载

        /** 获取类型信息列表 **/
        GetTypeList() {
            var param={p:1,rollpage:100000};
            INTERFACE_MODEL_RECORD.GET_RECORD_TYPE_LIST(param).then((res) => {
                 if(res.status > 0) return false;
                 this.typelist=res.data.list;
            });
        },

        /** 数据保存到浏览器 **/
        SaveDataToBrowser() {
            var data=JSON.stringify(this.recordtypelist);
            localStorage.setItem('addrecordtype',data);
        },

        /** 从浏览器取数据解析 **/
        ParseDataFromBrowser() {
            var data=localStorage.getItem('addrecordtype');
            data ? data : data=[];
            
            !data || data=='' || data==[] ? 
            this.recordtypelist=[{icon:'',name:'',parentid:''}] : 
            this.recordtypelist=JSON.parse(data);
        },

        /** 返回宠物管理组件 **/
        GoBackPets(isdellocal) {
            var navinfo={name:'记录类型管理',labelentry:'RecordType',components:'RecordType',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },

    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:120px;height:120px;display: inline-block;border-radius: 5px;}
.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
</style>